module.exports = __webpack_public_path__ + "img/sql2.433c71d3.png";